import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';

export const IconGreenCheckCutoutGroup: React.FC<SvgProps> = (props) => {
  return (
    <g fill="none" {...(props.group ?? {})}>
      <rect x="2" y="2" width="20" height="20" rx="10" fill="#379A15" />
      <path
        d="M16.3893 9L10.7964 15.292L8 13.1946"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  );
};

export const IconGreenCheckCutoutSvg: React.FC<SvgProps> = (props) => {
  const size = props.size ?? 48;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={size}
      width={size}
      viewBox="0 0 24 24"
      {...(props.svg ?? {})}
    >
      <IconGreenCheckCutoutGroup {...props} />
    </svg>
  );
};
